/* eslint-disable max-len */
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import AnimatedList from '../../../../../../components/Animation/AnimatedList'
import moment from 'moment'
import { convertEpochToDateFormat } from '../../../../../../CommonMethods/convertEpochToDateFormat'

const TableBody = ({
    tableData,
    indexNum,
}) => {
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const fieldTOUpdate = {
        'user_name': 'Username',
        'field': 'Fields',
        'timestamp': 'Timestamp',
        'old_value': 'Old Value',
        'new_value': 'New Value',
        'action': 'Action Performed',
        'comments': 'Comments',
        'user_id': 'ID',
        'organization_id': 'Organization ID',
        'subdivision_id': 'Subdivision ID',
        'patient_id': 'Patient ID'
    }
    const valuesToUpdate = {
        'inactive': 'Inactive',
        'active': 'Active',
    }
    const date = convertEpochToDateFormat(tableData?.timestamp, dateformat)
    // const date = dateformat?.includes('AM/PM')?moment(tableData?.timestamp).utcOffset('+5:30').format(`${dateformat.split(',')[0]} h:mm:ss A`):moment(tableData?.created_at).format(dateformat)
    return (
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.user_name}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">{tableData?.action}</td>
                        {/* <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">{fieldTOUpdate[tableData?.field]?fieldTOUpdate[tableData?.field]:tableData?.field}</td> */}
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">
                            {fieldTOUpdate[tableData?.field] &&
                                typeof fieldTOUpdate[tableData?.field] === 'string'
                                ? fieldTOUpdate[tableData?.field].replace(/_/g, " ")
                                : (tableData?.field || '').toString().replace(/_/g, " ")}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all" style={{ lineBreak: 'anywhere' }}>{tableData?.old_value === '' ? '-' : valuesToUpdate[tableData?.old_value] ? valuesToUpdate[tableData?.old_value] : tableData?.old_value}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] break-all' style={{ lineBreak: 'anywhere' }}>{tableData?.new_value === '' ? '-' : valuesToUpdate[tableData?.new_value] ? valuesToUpdate[tableData?.new_value] : tableData?.new_value}</td>
                        <td maxLength={300} className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize rounded-tl-sm rounded-bl-sm">{tableData?.comments === '' ? '-' : tableData?.comments}</td>
                    </>

                } />

        </>
    )
}

export default TableBody